import React from "react";
import Axios from "axios";
import "./style.css";

export default class App extends React.Component {

    constructor(props) {
        super(props);
        this.getCData = this.getData.bind(this);
        this.getCountryData = this.getCountryData.bind(this);

    }

    state = {
        confirmed: 0,
        recovered: 0,
        deaths: 0,
        countries: []
    }

    componentDidMount() {
        this.getData();
    }
    async getData() {

        const resApi = await Axios.get("https://covid19.mathdro.id/api");
        const resCountries = await Axios.get("https://covid19.mathdro.id/api/countries");
        const countries = resCountries.data.countries;
        
        this.setState({
            confirmed: resApi.data.confirmed.value,
            recovered: resApi.data.recovered.value,
            deaths: resApi.data.deaths.value,
            countries:countries
        });
        
    }
    async getCountryData(e) {
        if (e.target.value === "World Wide") {
            return this.getData();
        }
           try {
                const resCountyData = await Axios.get(`https://covid19.mathdro.id/api/countries/${e.target.value}`);
                this.setState({
                    confirmed: resCountyData.data.confirmed.value,
                    recovered: resCountyData.data.recovered.value,
                    deaths: resCountyData.data.deaths.value
                });
            } catch (e) {
                if (e.response.status === 404) {
                    this.setState({
                        confirmed: "No Data Available",
                        recovered: "No Data Available",
                        deaths: "No Data Available"
                    });
                }
            }
    }

    async geCData(){
        try {
            const resCountyData = await Axios.get("https://covid19.mathdro.id/api/countries/LK");
            this.setState({
                confirmed: resCountyData.data.confirmed.value,
                recovered: resCountyData.data.recovered.value,
                deaths: resCountyData.data.deaths.value
            });
        } catch (e) {

        }
    }


    renderCountryOptions() {
        return this.state.countries.map(country => {
            return <option key={country.i}>{country.name}</option>
        });
    }



    render() {
        return (
            <div className="container">
                <h1>Corona Update</h1>
                <br></br>
                <h6>Search Here :
                <select onChange={this.getCountryData} className="all">
                    <option>World Wide</option>
                    { this.renderCountryOptions()}
                </select>
                </h6>
                <br></br>
                <br></br>
                <hr></hr>
                <div className="flex">
                    <div className="box confirmed">
                        <h3>Confirmed  </h3>
                        <h4>{this.state.confirmed}</h4>
                    </div>
                    <div className="box recovered">
                        <h3>Recovered </h3>
                        <h4>{this.state.recovered}</h4>
                    </div>
                    <div className="box deaths">
                        <h3>&nbsp;&nbsp;Deaths&nbsp;&nbsp;</h3>
                        <h4>{this.state.deaths}</h4>
                    </div>
                </div>
               <br></br>
                <br></br>
                <hr></hr>
                <br></br>
                <h5 className="deco">Developed by | Ridma Randika <br/><span className="dc">Note : *Details may not be Accurate by some technical issues</span></h5>
            </div>
        )
    }
}